var _excluded = ["direction", "classNames", "children", "timeout"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// SlideTransition class uses CSSTransition with slide-left and slide-right classNames, depending on the prop direction. The transition is 250ms long.
import { useCallback, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import ThemeExport from "../ThemeExport.js";
import { jsx as _jsx } from "react/jsx-runtime";
var DISPLAY_CONTENTS = {
  display: 'contents'
};
/**
 * Slides one component overtop of another component.
 * Defaults to sliding left, unless `direction='right'` is provided.
 * Timeout defaults to 200ms.
 */
function SlideTransition(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'left' : _ref$direction,
    classNamesProp = _ref.classNames,
    children = _ref.children,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? ThemeExport.transitionMidMs : _ref$timeout,
    props = _objectWithoutProperties(_ref, _excluded);
  var nodeRef = useRef(null);

  // Mimics findDOMNode for CSSTransition.
  // Keying on `in` rather than `children` avoids re-creating the ref callback
  // on every render, which would needlessly detach/re-attach the ref.
  var setRef = useCallback(node => {
    var _ref2;
    nodeRef.current = (_ref2 = node === null || node === void 0 ? void 0 : node.firstElementChild) !== null && _ref2 !== void 0 ? _ref2 : null;
  },
  // `inProp` is intentionally a dependency: toggling `in` must re-create the
  // callback so the ref re-attaches and re-reads `firstElementChild` when the
  // child appears/disappears.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [props.in]);
  return /*#__PURE__*/_jsx(CSSTransition, _objectSpread(_objectSpread({
    nodeRef: nodeRef,
    timeout: timeout,
    classNames: classNames("slide-".concat(direction), classNamesProp)
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props), {}, {
    children: /*#__PURE__*/_jsx("div", {
      ref: setRef,
      style: DISPLAY_CONTENTS,
      children: children
    })
  }));
}
export default SlideTransition;
//# sourceMappingURL=SlideTransition.js.map